import React from 'react';

interface ArrowRightIconProps {
  className?: string;
}

export const ArrowRightIcon: React.FC<ArrowRightIconProps> = ({
  className = 'w-5 h-5',
}) => {
  return (
    <svg
      className={className}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5 12h14M12 5l7 7-7 7'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
